import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {Checkbox} from '@/components/inputs/Checkbox'
import {useAuthContent} from '@/content/user/authentication'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

type FormSignUpProps = {isDisabled?: boolean}

export const FormSignUp: FC<FormSignUpProps> = ({isDisabled}) => {
  const {t} = useTranslation()
  const {
    formAuth: {createAccountTitle, createAccountCheckbox},
  } = useAuthContent()

  return (
    <>
      <Checkbox
        name="create_account"
        label={
          <div>
            <Text>{t(createAccountTitle)}</Text>
            <div className="message">
              <Text variant={TextVariant.text14} color={theme.palette.text.light}>
                {t(createAccountCheckbox)}
              </Text>
            </div>
          </div>
        }
        isBoolean
        isDisabled={isDisabled}
      />
      <style jsx>{`
        .message {
          margin-top: ${theme.spacing[1]};
        }
      `}</style>
    </>
  )
}
